import React from "react";
import CommonLayout from "../../pages/Layout/CommonLayout";
import { Outlet } from "react-router-dom";
import useReport from "./useReport";

const Report = () => {
  const drawerMenu = useReport();

  return (
    <CommonLayout drawerMenu={drawerMenu?.drawerMenu}>
      <Outlet />
    </CommonLayout>
  );
};

export default Report;
